import { useDispatch as useReduxDispatch } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import axios from 'axios';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import Reducers from './reducers';

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, Reducers)


const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: [thunk]
});

export const useDispatch = () => useReduxDispatch();
const persister = persistStore(store);

const { dispatch } = store;
axios.interceptors.request.use(function (config) {
  dispatch({ type: 'SHOW_SPINNER' });
  return config;
}, function (error) {
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  dispatch({ type: 'HIDE_SPINNER' });
  return response;
}, function (error) {
  return Promise.reject(error);
})

export { store, persister };